export const restMonitoring = {
  data() {
    return {
      activeUsers: [],
      activityLogs: [],
      activeLayers: [],
      layerHistory: [],
      layerSessions: [],
      mapHistory: [],
      monitoringSummary: null,
      totalPagesLayerSessions: 0,
      totalPagesMapHistory: 0
    }
  },
  methods: {
    getActiveUsers() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/monitoring/active-users`)
        .then((response) => {
          this.activeUsers = response.data || []
        })
        .catch((error) => { console.log(error) })
    },
    getActivityLogs(page, operationType, dateFrom, dateTo, search, sortKey, sortOrder, module) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page: page || 1, size: this.pageSize || 15 })
      if (operationType) params.set('operation_type', operationType)
      if (dateFrom) params.set('date_from', dateFrom)
      if (dateTo) params.set('date_to', dateTo)
      if (search) params.set('search', search)
      if (module) params.set('module', module)
      if (sortKey) {
        params.set('sort', sortKey)
        params.set('order', sortOrder || 'asc')
      }
      return this.$http.get(`${backendurl}api/v1/monitoring/activity?${params.toString()}`)
        .then((response) => {
          this.activityLogs = response.data || []
          this.totalPages = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => { console.log(error) })
    },
    // Las etiquetas de módulo viven en el backend (routes/log_module.go), que es
    // donde se derivan desde `collection` — el <select> las pide en vez de
    // repetir la lista acá y arriesgar que se desincronicen.
    getLogModules() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/monitoring/modules`)
        .then((response) => response.data || [])
        .catch((error) => { console.log(error); return [] })
    },
    getActiveLayers(search) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams()
      if (search) params.set('search', search)
      const qs = params.toString() ? `?${params.toString()}` : ''
      return this.$http.get(`${backendurl}api/v1/monitoring/active-layers${qs}`)
        .then((response) => {
          this.activeLayers = response.data || []
        })
        .catch((error) => { console.log(error) })
    },
    getLayerHistory() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/monitoring/layer-history`)
        .then((response) => {
          this.layerHistory = response.data || []
        })
        .catch((error) => { console.log(error) })
    },
    getLayerSessions(page, dateFrom, dateTo, search, sortKey, sortOrder) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page: page || 1, size: 15 })
      if (dateFrom) params.set('date_from', dateFrom)
      if (dateTo) params.set('date_to', dateTo)
      if (search) params.set('search', search)
      if (sortKey) {
        params.set('sort', sortKey)
        params.set('order', sortOrder || 'asc')
      }
      return this.$http.get(`${backendurl}api/v1/monitoring/layer-sessions?${params.toString()}`)
        .then((response) => {
          this.layerSessions = response.data || []
          this.totalPagesLayerSessions = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => { console.log(error) })
    },
    getMapHistory(page, dateFrom, dateTo, search, sortKey, sortOrder) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page: page || 1, size: 15 })
      if (dateFrom) params.set('date_from', dateFrom)
      if (dateTo) params.set('date_to', dateTo)
      if (search) params.set('search', search)
      if (sortKey) {
        params.set('sort', sortKey)
        params.set('order', sortOrder || 'asc')
      }
      return this.$http.get(`${backendurl}api/v1/monitoring/map-history?${params.toString()}`)
        .then((response) => {
          this.mapHistory = response.data || []
          this.totalPagesMapHistory = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => { console.log(error) })
    },
    getMapsList() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/maps/`)
        .then(r => r.data || [])
        .catch(e => { console.error(e); return [] })
    },
    getChartLayerActivity(mapId, dateFrom, dateTo, search) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams()
      if (mapId) params.set('map_id', mapId)
      if (dateFrom) params.set('date_from', dateFrom)
      if (dateTo) params.set('date_to', dateTo)
      if (search) params.set('search', search)
      const qs = params.toString() ? `?${params.toString()}` : ''
      return this.$http.get(`${backendurl}api/v1/monitoring/charts/layer-activity${qs}`)
        .then(r => r.data || [])
        .catch(e => { console.error(e); return [] })
    },
    getChartUsersByGroup(dateFrom, dateTo) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams()
      if (dateFrom) params.set('date_from', dateFrom)
      if (dateTo) params.set('date_to', dateTo)
      const qs = params.toString() ? `?${params.toString()}` : ''
      return this.$http.get(`${backendurl}api/v1/monitoring/charts/users-by-group${qs}`)
        .then(r => r.data || [])
        .catch(e => { console.error(e); return [] })
    },
    getChartMapVisitsByHour(dateFrom, dateTo, search) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams()
      if (dateFrom) params.set('date_from', dateFrom)
      if (dateTo) params.set('date_to', dateTo)
      if (search) params.set('search', search)
      const qs = params.toString() ? `?${params.toString()}` : ''
      return this.$http.get(`${backendurl}api/v1/monitoring/charts/map-visits-by-hour${qs}`)
        .then(r => r.data || [])
        .catch(e => { console.error(e); return [] })
    },
    getChartRequestsByDate(dateFrom, dateTo) {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams()
      if (dateFrom) params.set('date_from', dateFrom)
      if (dateTo) params.set('date_to', dateTo)
      const qs = params.toString() ? `?${params.toString()}` : ''
      return this.$http.get(`${backendurl}api/v1/monitoring/charts/requests-by-date${qs}`)
        .then(r => r.data || [])
        .catch(e => { console.error(e); return [] })
    },
    getSummary() {
      const backendurl = this.$store.getters.backendurl
      return this.$http.get(`${backendurl}api/v1/monitoring/summary`)
        .then((response) => {
          this.monitoringSummary = response.data || null
        })
        .catch((error) => { console.log(error) })
    }
  }
}
